export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/checkVerified.680646d6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};